"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Filtr_1 = require("../../../../components/Filtr/Filtr");
var fields_1 = require("../../../../components/Form/fields");
var hooks_1 = require("../../../../hooks");
var BlockSpecializace = function (_a) {
    var _b, _c;
    var label = _a.label, value = _a.value, handleChange = _a.handleChange, name = _a.name;
    var _d = hooks_1.useCiselnik('specializace'), data = _d.data, loading = _d.loading, error = _d.error;
    if (loading) {
        return react_1.default.createElement("div", null, "loading");
    }
    if (error) {
        return react_1.default.createElement("div", null, error);
    }
    if (handleChange && name) {
        handleChange(name, (_b = fields_1.getSpecializaceById(value, data || [])) === null || _b === void 0 ? void 0 : _b.nazev);
    }
    return (react_1.default.createElement("div", null,
        label,
        react_1.default.createElement("br", null),
        react_1.default.createElement(Filtr_1.Filtr, null, (_c = fields_1.getSpecializaceById(value, data || [])) === null || _c === void 0 ? void 0 : _c.nazev)));
};
BlockSpecializace.defaultProps = {
    handleChange: undefined,
    name: undefined,
};
exports.default = BlockSpecializace;
